/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "utils/url",
    "service/channel",
    "service/messageframes",
    "service/messageframe_channel",
    "service/ajax_channel",
    "service/cross_domain_ajax_channel",
    "service/constrained_channel",
    "service/ews_search_channel",
    "service/async_call_channel",
    "service/mcp_channel",
    "underscore"
  ],
  function(
    url,
    Channel,
    MessageFrames,
    MessageFrameChannel,
    AjaxChannel,
    CrossDomainAjaxChannel,
    ConstrainedChannel,
    EWSChannel,
    AsyncCallChannelModule,
    MCPChannelModule,
    _
  ) {

    function ChannelFactory(options) {
      this.options = options;
      if (options.prepareRequest) {
        this.prepareRequest = options.prepareRequest;
      }
      this.messageFrames =  new MessageFrames(this.options);
    }

    _.extend(ChannelFactory.prototype, {

      _useFactory: function(channel) {
        if (channel instanceof Channel) return false;

        if (_.isObject(channel) && channel.url) {
          return true;
        }

        if (_.isString(channel)) return true;

        return false;
      },
      
      createChannel: function (channel, options) {
        
        options = options || {};

        if (!channel || !(this._useFactory(channel) && (!_.isObject(channel) || channel.useFactory !== false))) return channel;

        channel = _.clone(channel);
        var channelType = channel.channelType || 'CrossDomainAjaxChannel';

        if (_.isString(channel)) {
          channel = {
            url: channel
          };
        }

        if (options && options.trace === false) {
          channel.trace = false;
        }

        var resultChannel;
        var constraint = channel.constraint;
        if (constraint) delete channel.constraint;
           
        if (url.isRelative(channel.url)) { // TODO: re-enable after login handling is done for all channels || url.sameOrigin(window.location.href, channel)) {
          resultChannel = new AjaxChannel(channel, this.options);
        } else {
          if (!channel.messageFrames) channel.messageFrames = this.messageFrames;

          resultChannel = this.getChannelInstance(channel, options, channelType);
        }

        if (constraint) {
          resultChannel = new ConstrainedChannel(channel, _.extend({}, {channel: resultChannel,
                                                                        constraint: constraint }, this.options));
        }

        if (options.bindPrepareRequests && !resultChannel.prepareRequest && this.prepareRequest) {
          var that = this;
          resultChannel.prepareRequest = function(request) {
            return that.prepareRequest(this, request);
          }.bind(resultChannel);
        }        
        return resultChannel;
      },

      getChannelInstance: function (channel, options, channelType) {
        var channelInstance;

        // If backend $$USE_LEGACY_MESSAGEFRAME_CHANNEL$$ or useLegacyMessageFrameChannel application property is set to TRUE use MessageFrameChannel
        if (options.useLegacyMessageFrameChannel === true) {
          channelType = 'MessageFrameChannel';
        }
        
        switch(channelType) {
        case 'MessageFrameChannel':
          channelInstance = new MessageFrameChannel(channel, options);
          break;
        case 'AjaxChannel':
          channelInstance = new AjaxChannel(channel, options);
          break;
        case 'EWSChannel':
          channelInstance =  new EWSChannel({
            parentChannel: new CrossDomainAjaxChannel({ url: channel.url })
          }, {
            urlTemplate: ""
          });
          break;
        case 'AsyncCallChannel':
          {
            let parentChannel;
            if (channel.url) {
              parentChannel = new CrossDomainAjaxChannel({url: channel.url});
            }
            let channelOptions = Object.assign({}, options || {});
            channelOptions.parentChannel = parentChannel;
            channelInstance = new AsyncCallChannelModule.AsyncCallChannel(channel, {parentChannel: parentChannel});
          }
          break;
        case 'MCPChannel':
          {
            let parentChannel;
            if (channel.url) {
              parentChannel = new CrossDomainAjaxChannel({url: channel.url});
            }
            let channelOptions = Object.assign({}, options || {});
            channelOptions.parentChannel = parentChannel;
            channelInstance = new MCPChannelModule.MCPChannel(channel, {parentChannel: parentChannel});
          }
          break;

        default:
          channelInstance = new CrossDomainAjaxChannel(channel, options);
        }

        return channelInstance;
      }
    });
    
    return ChannelFactory;
});
